import React from 'react';
import styled, { css } from 'styled-components';

// Components
import { IconStatusCheck } from 'wg-fe-ui';

interface Props {
  isSelected: boolean;
}

const RadioCheck: React.FC<React.PropsWithChildren<Props>> = ({
  isSelected,
}) => {
  return (
    <Wrapper isSelected={isSelected}>
      {isSelected && <IconStatusCheck color="white" />}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ isSelected?: boolean }>`
  width: 2.8rem;
  height: 2.8rem;

  border-radius: 100%;
  border: 3px solid #e4e4e4;

  & svg {
    width: 100%;
    height: 100%;
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      border: 3px solid ${({ theme }) => theme.primary[500]};
      background-color: ${({ theme }) => theme.primary[500]};
    `}
`;

export default RadioCheck;
